import React, { useMemo } from 'react';
import { FlexboxGrid } from 'rsuite';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy,
  selectConfigExpressRegistrationTypeVerbiage,
} from '../../store/slices/config/configSelectors';
import { MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM } from '../../common/enums';
import Notice from '../user-feedback/Notice';

export interface GenericApplyWarningProps {
  message: string;
}

const GenericApplyWarning: React.FC<GenericApplyWarningProps> = ({
  message,
}) => {
  const selectedPermitTypeVerbiage = useSelector(
    selectConfigExpressRegistrationTypeVerbiage
  );
  const multipleLicenseStatus = useSelector(
    selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy
  );
  const isWarnPolicy = useMemo(() => {
    return (
      multipleLicenseStatus ===
        MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN ||
      multipleLicenseStatus ===
        MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN_AND_SHOW_LICENSE_DETAILS
    );
  }, [multipleLicenseStatus]);

  const noticeType = useMemo(() => {
    return isWarnPolicy ? 'warning' : 'error';
  }, [multipleLicenseStatus, selectedPermitTypeVerbiage]);

  return (
    <FlexboxGrid>
      <FlexboxGrid.Item colspan={24}>
        <Notice
          type={noticeType}
          message={message}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default GenericApplyWarning;
